<template>
  <div v-if="data" class="position-relative" id="studentReportsView">
    <neo-print-wrapper title="Student Report">
      <div class="d-flex mb-3">
        <div class="student-photo-print">
          <a-avatar shape="square" :size="70" :icon="student.photo ? '' : 'user'" :src="student.photo"/>
        </div>
        <div class="ml-2">
          <h5 class="font-weight-bold mb-0">{{ student.first_name }} {{ student.last_name }}</h5>
          <p class="mb-0" v-if="student.enrollment">
            Class:
            <span class="font-weight-bold mr-1">
              {{ student.enrollment[0].school_class ? student.enrollment[0].school_class.name : '' }}
            </span>|  Section:
            <span class="font-weight-bold mr-1">
              {{ student.enrollment[0].section ? student.enrollment[0].section.name : '' }}
            </span>|  Roll Number:
            <span class="font-weight-bold mr-1">
              {{ student.enrollment[0].roll_no }}
            </span>|  Student Code:
            <span class="font-weight-bold mr-1">
              {{ student.student_code }}
            </span>
          </p>
          <p class="mb-2" v-if="student.enrollment">
            D.O.B:
            <span class="font-weight-bold mr-1">
              {{ moment(student.dob).format('DD-MM-YYYY') }}
            </span>|  Gender:
            <span class="font-weight-bold mr-1">
              {{ student.gender }}
            </span>|  Category:
            <span class="font-weight-bold mr-1">
              {{ student.category }}
            </span>
          </p>
        </div>
      </div>
      <a-divider />
      <div class="mt-3">
        <section class="basicInfo">
          <p class="font-weight-bold text-muted mb-2">Basic Info</p>
          <data-field :data="basicInfo" />
        </section>
        <section class="mt-2" v-if="options.showMedicalInfo">
          <a-divider />
          <p class="font-weight-bold text-muted my-2">Medical</p>
          <data-field :data="medicalInfo" />
        </section>
        <section class="mt-2" v-if="options.showContact">
          <a-divider />
          <p class="font-weight-bold text-muted my-2">Contact</p>
          <data-field :data="contactInfo" />
        </section>
        <section class="mt-2" v-if="options.showAcademicInfo">
          <a-divider />
          <p class="font-weight-bold text-muted my-2">Academic</p>
          <data-field :data="academicInfo" />
        </section>
        <section class="mt-2" v-if="options.showPreviousSchoolInfo">
          <a-divider />
          <p class="font-weight-bold text-muted my-2">Previous School</p>
          <data-field :data="previousSchoolInfo" />
        </section>
        <section class="mt-2" v-if="options.showParentsInfo">
          <a-divider />
          <p class="font-weight-bold text-muted my-2">Parents</p>
          <data-field :data="parentInfo" :isParent="true" :showContact="options.showParentsContactInfo"/>
        </section>
        <section class="mt-2" v-if="options.showAttendanceInfo">
          <a-divider />
          <p class="font-weight-bold text-muted my-2">Attendance</p>
          <div class="row mb-4">
            <div class="col-md-4">
              <div class="d-flex">
                <a-progress strokeLinecap="square" :percent="data.attendance_data.percentage" type="circle" :width="80"/>
                <div class="pl-3">
                  <p class="mb-0">Total Working Days: <strong>{{data.attendance_data.total_working_day}}</strong></p>
                  <p class="mb-0">Total Present Days: <strong>{{data.attendance_data.total_present}}</strong></p>
                  <p class="mb-0">Total Absent Days: <strong>{{data.attendance_data.total_absent}}</strong></p>
                </div>
              </div>
            </div>
            <div class="col-md-8">
              <p class="font-weight-bold mb-2">Absent Days:</p>
              <div class="d-flex flex-row flex-wrap">
                <a-tag color="red" class="mb-2" v-for="absentDays in data.attendance_data.absent_days" :key="absentDays.id">
                  {{moment(absentDays.date).format('ddd')}}, {{moment(absentDays.date).format('ll')}}
                </a-tag>
              </div>
            </div>
          </div>
        </section>
        <section class="mt-2" v-if="options.showFeeInfo">
          <a-divider />
          <p class="font-weight-bold text-muted my-2">Fees</p>
          <report-fees :data="data.fee_data"/>
        </section>
        <section class="mt-2" v-if="options.showExamInfo">
          <a-divider />
          <p class="font-weight-bold text-muted my-2">Exam Performance</p>
          <report-exam :data="data.exam_marks"/>
        </section>

        <div class="row">
        </div>
        <vue-custom-scrollbar class="scroll-area">
          <!-- <table class="table table-bordered table-sm">
            <thead class="bg-light">
              <tr class="text-center">
                <th rowspan="3">Subjects</th>
                <th :colspan="data.class_section_exams.length * 3">
                  Exams
                </th>
                <th :colspan="data.internals.length * 2">Internals</th>
                <th rowspan="2" colspan="5">Final Result</th>
              </tr>
              <tr class="text-center">
                <th colspan="3" v-for="classExam in data.class_section_exams" :key="classExam.id">
                  {{ classExam.exam.name }} <span v-if="getExamWeightage(classExam.exam.id)">({{getExamWeightage(classExam.exam.id)}})</span>
                </th>
                <th colspan="2" v-for="internal in data.internals" :key="internal.internal_assessment.id">
                  {{internal.internal_assessment.name}} <span v-if="getInternalWeightage(internal.internal_assessment.id)">({{getInternalWeightage(internal.internal_assessment.id)}})</span>
                </th>
              </tr>
              <tr>
                <template v-for="classExam in data.class_section_exams">
                  <th :key="'score' + classExam.id">Score</th>
                  <th :key="'passmark' + classExam.id">Pass</th>
                  <th :key="'fullmark' + classExam.id">Full</th>
                </template>
                <template v-for="internal in data.internals">
                  <th :key="'score' + internal.id">Score</th>
                  <th :key="'fullmark' + internal.id">Full</th>
                </template>
                <th>Score</th>
                <th>Pass</th>
                <th>Full</th>
                <th>Grade</th>
                <th>Credit</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="subject in data.subjects" :key="subject.id">
                <th>{{ subject.abbreviation }}</th>
                <template v-for="classExam in data.class_section_exams">
                  <td :key="subject.id + 'score' + classExam.id"
                  :class="[`${getSubjectExamMark(subject.id, classExam, 'isfailed') ? 'text-danger' : ''}`]"
                  >
                    {{ getSubjectExamMark(subject.id, classExam, 'score') }}
                  </td>
                  <td :key="subject.id + 'passmark' + classExam.id">
                    {{getSubjectExamMark(subject.id, classExam, 'passmark')}}
                  </td>
                  <td :key="subject.id + 'fullmark' + classExam.id">
                    {{getSubjectExamMark(subject.id, classExam, 'fullmark')}}
                  </td>
                </template>
                <template v-for="internal in data.internals">
                  <td :key="subject.id + 'score' + internal.internal_assessment.id">
                    {{ getSubjectInternalMark(subject.id, internal.internal_assessment.id, 'score') }}
                  </td>
                  <td :key="subject.id + 'fullmark' + internal.internal_assessment.id">
                    {{ getSubjectInternalMark(subject.id, internal.internal_assessment.id, 'fullmark') }}
                  </td>
                </template>
                <th :class="[`${getStudentFinalMark(subject.id, 'isfailed') ? 'text-danger' : ''}`]">
                  {{ getStudentFinalMark(subject.id, 'score') }}
                </th>
                <td>{{ getStudentFinalMark(subject.id, 'passmark') }}</td>
                <td>{{ getStudentFinalMark(subject.id, 'fullmark') }}</td>
                <th>{{ getStudentFinalMark(subject.id, 'grade') }}</th>
                <th>{{ getStudentFinalMark(subject.id, 'credit') }}</th>
              </tr>
            </tbody>
          </table>
          <table class="table table-bordered table-sm">
            <thead class="bg-light">
              <tr>
                <th>Total Score</th>
                <th>Full Mark</th>
                <th>Total PC</th>
                <th>Grade</th>
                <th>Credit</th>
                <th>Attendance</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th>
                  {{data.student_final_declared_marks.total_mark_score}}
                </th>
                <th>
                  {{data.student_final_declared_marks.total_exam_full_mark}}
                </th>
                <th>
                  {{data.student_final_declared_marks.mark_percentage}}%
                </th>
                <th>
                  {{data.student_final_declared_marks.grade}}
                </th>
                <th>
                  {{data.student_final_declared_marks.credit_point}}
                </th>
                <th>
                  {{data.attendance.present_days}} / {{data.attendance.working_days}} ({{data.attendance.percent}}%)
                </th>
              </tr>
            </tbody>
          </table> -->
        </vue-custom-scrollbar>
      </div>

      <!-- Print Button -->
      <div class="position-absolute neo-tr-5 d-print-none">
        <button
          type="button"
          class="btn btn-light btn-sm btn-with-addon"
          @click="print"
        >
          <span class="btn-addon">
            <i class="btn-addon-icon fe fe-printer" />
          </span>
          Print
        </button>
      </div>
    </neo-print-wrapper>
  </div>
</template>

<script>
import { find } from 'lodash'
import moment from 'moment'
import { basicInfo, contactInfo, academicInfo, electivesInfo, previousSchoolInfo, parentInfo, medicalInfo } from '@/components/student/Report/fields'

import DataField from './DataField'

import vueCustomScrollbar from 'vue-custom-scrollbar'
import NeoPrintWrapper from '@/components/layout/Print/Default'

import ReportFees from '@/components/student/Report/Fees/index'
import ReportExam from '@/components/student/Report/Exam/index'

export default {
  props: ['student', 'data', 'options'],
  components: {
    ReportFees,
    ReportExam,
    vueCustomScrollbar,
    DataField,
    NeoPrintWrapper,
  },
  mounted: function() {
    this.setStudentData(this.data)
  },
  watch: {
    student: function(val) {
      if (val) {
        this.setStudentData(this.data)
      }
    },
  },
  data: function() {
    return {
      basicInfo: {},
      contactInfo: {},
      academicInfo: {},
      electivesInfo: {},
      previousSchoolInfo: {},
      parentInfo: {},
      medicalInfo: {},
    }
  },
  methods: {
    moment,
    setStudentData(data) {
      this.basicInfo = basicInfo(data.basic_info)
      this.contactInfo = contactInfo(data.basic_info.contact)
      this.academicInfo = academicInfo(data.basic_info.enrollment[0])
      this.electivesInfo = electivesInfo(data.student_electives)
      this.previousSchoolInfo = previousSchoolInfo(data.basic_info)
      this.parentInfo = parentInfo(data.basic_info.student_parents)
      this.medicalInfo = medicalInfo(data.basic_info)
    },
    getSubjectExamMark(subjectId, classExam, type = 'score') {
      const subject = find(classExam.student_exam_marks, { subject_id: subjectId })
      if (subject) {
        if (type === 'score') {
          return subject.exam_mark_score
        }
        if (type === 'passmark') {
          return subject.exam_pass_mark
        }
        if (type === 'fullmark') {
          return subject.exam_full_mark
        }
        if (type === 'isfailed') {
          return subject.is_failed === 1
        }
        if (type === 'isabsent') {
          return subject.is_absent === 1
        }
      }
    },
    getSubjectInternalMark(subjectId, internalId, type = 'score') {
      const internal = find(this.data.internal_assessment_mark, {
        subject_id: subjectId,
        internal_assessment_id: internalId,
      })
      if (internal) {
        if (type === 'score') {
          return internal.final_student_internal_assessment_mark
        }
        if (type === 'fullmark') {
          return internal.full_mark
        }
      }
    },
    getStudentFinalMark(subjectId, type = 'score') {
      const subject = find(this.data.student_final_marks, { subject_id: subjectId })
      if (subject) {
        if (type === 'score') {
          return subject.exam_mark_score
        }
        if (type === 'passmark') {
          return subject.exam_pass_mark
        }
        if (type === 'fullmark') {
          return subject.exam_full_mark
        }
        if (type === 'grade') {
          return subject.exam_mark_grade
        }
        if (type === 'credit') {
          return subject.exam_mark_credit_point
        }
        if (type === 'isfailed') {
          return subject.is_failed === 1
        }
        if (type === 'isabsent') {
          return subject.is_absent === 1
        }
      }
    },
    getExamWeightage (examId) {
      const exam = find(this.data.final_exams, { class_section_exam_id: examId })
      if (exam) {
        return exam.final_exam_weightage
      }
    },
    getInternalWeightage(internalId) {
      const internal = find(this.data.internals, { internal_a_id: internalId })
      if (internal) {
        return internal.internal_assessment_weightage
      }
    },
    print() {
      this.$htmlToPaper('studentReportsView')
    },
  },
}
</script>
